"use strict";

export default [
  "$scope",
  "$rootScope",
  "$utils",
  "$location",
  "$http",
  "AppealsRestService",
  "Notification",
  "MunicipalityRestService",
  "ModalService",
  "FilterService",
  function (
    $scope,
    $rootScope,
    $utils,
    $location,
    $http,
    AppealsRestService,
    Notification,
    MunicipalityRestService,
    ModalService,
    FilterService
  ) {
    // Загрузка данных обращений
    $scope.openControlSidebar = $utils.openControlSidebar;

    const loadAppeals = () => {
      AppealsRestService.getAll()
        .$promise.then((response) => {
          // Теперь данные находятся в response._embedded
          $scope.appeals = response._embedded;
          $scope.pagination = response.page;
        })
        .catch((error) => {
          console.error("Ошибка при загрузке обращений:", error);
        });
    };

    // Инициализация данных
    loadAppeals();

    $scope.isFilterModalOpen = false;
    $scope.municipalities = [];
    $scope.searchData = FilterService.searchData;
    $scope.filterData = FilterService.filterData;

    $scope.isFilterSelected = function () {
      return !!$scope.selectedReason || !!$scope.selectedMunicipality;
    };

    $scope.propsFilter = function (props, search) {
      var out = [];

      if (angular.isArray(props)) {
        props.forEach(function (item) {
          var itemNameMatch =
            String(item.name)
              .toLowerCase()
              .indexOf(search || "") !== -1;
          if (itemNameMatch) out.push(item);
        });
      }
      return out;
    };

    function loadMunicipalities() {
      MunicipalityRestService.get({
        filters: [`'status' EQ 'ENABLED'`],
        sorts: ["npp:ASC", "name:ASC"],
      }).$promise.then(function (response) {
        $scope.municipalities = response._embedded;
      });
    }

    loadMunicipalities();

    $scope.applyFilter = function () {
      let filters = [];

      if ($scope.filterData.type) {
        filters.push(`EXTRA:'type' EQ '${$scope.filterData.type}'`);
      }

      if (
        $scope.filterData.municipalities &&
        $scope.filterData.municipalities.length > 0
      ) {
        const municipalityIds = $scope.filterData.municipalities
          .map((m) => m.id)
          .join(";");
        filters.push(`EXTRA:'placesmunicipality' EQ '${municipalityIds}'`);
      }

      let searchs = [];
      if ($scope.searchData.search) {
        searchs.push(
          `'shortName':'${$scope.searchData.search}'`,
          `'name':'${$scope.searchData.search}'`
        );
      }

      console.log($scope.filterData, $scope.searchData);

      AppealsRestService.getAll({
        filters,
        search: searchs,
      }).$promise.then(
        (response) => {
          $scope.appeals = response._embedded;
        },
        (error) => {
          Notification.warning({
            title: "Внимание!",
            message: "Ошибка при применении фильтра",
          });
          console.error("Ошибка при применении фильтра:", error);
        }
      );
    };

    $scope.resetFilter = function () {
      $scope.filterData = {
        type: "place",
        municipalities: [],
      };
    };

    $scope.mapType = function (type) {
      switch (type) {
        case "place":
          return "Подбор земельного участка";
        case "support":
          return "Подбор мер поддержки";
        case "maintenance":
          return "Взятие проекта на сопровождение";
      }
    };

    $scope.showConfirmModal = function (appealId) {
      ModalService.warning({
        message: "Вы действительно хотите создать проект на основе обращения?",
        apply: "Да",
        cancel: "Нет",
      })
        .result.then(() => {
          $scope.convertToProject(appealId);
        })
        .catch((err) => {
          if (err) {
            Notification.danger({
              title: "Ошибка!",
              message: err
                ? err.data
                  ? err.data.status + ":" + err.data.message
                  : err.message || err
                : "Произошла ошибка при создании проекта.",
            });
          }
          $scope.loading = false;
        });
    };

    $scope.isModalOpen = false;
    $scope.formData = {
      id: "",
      projectManager: "",
      investorDate: "",
      feedbackDate: "",
    };
    $scope.managers = [];

    $scope.openModal = function (appealId) {
      $scope.isModalOpen = true;
      $scope.formData.id = appealId;
      $scope.loadAppealData(appealId);
      $scope.loadManagers();
    };

    $scope.closeModal = function () {
      $scope.isModalOpen = false;
      $scope.resetFormData();
      $scope.isFormValid = false;
    };

    $scope.resetFormData = function () {
      $scope.formData = {
        id: "",
        projectManager: "",
        investorDate: "",
        feedbackDate: "",
      };
    };

    $scope.loadAppealData = function (appealId) {
      AppealsRestService.get({ treatmentId: appealId })
        .$promise.then((response) => {
          $scope.formData = response;
        })
        .catch((error) => {
          console.error("Ошибка при загрузке данных обращения:", error);
        });
    };

    $scope.loadManagers = function () {
      $http
        .get("/api/managers")
        .then((response) => {
          $scope.managers = response.data;
        })
        .catch((error) => {
          console.error("Ошибка при загрузке списка менеджеров:", error);
        });
    };

    $scope.saveData = function () {
      const appealId = $scope.formData.id;
      AppealsRestService.update({ treatmentId: appealId }, $scope.formData)
        .$promise.then(() => {
          alert("Данные успешно сохранены!");
          $scope.closeModal();
          loadAppeals(); // Перезагрузка списка обращений
        })
        .catch((error) => {
          console.error("Ошибка при сохранении данных:", error);
          alert("Ошибка при сохранении данных");
        });
    };

    $scope.convertToProject = function (appealId) {
      AppealsRestService.toProject({ id: appealId }, null).$promise.then(
        function () {
          Notification.success({
            title: "Успешно!",
            message: "Обращение переведено в проект",
          });
          loadAppeals();
        },
        function (error) {
          Notification.warning({
            title: "Внимание!",
            message: "Ошибка при переводе в проект",
          });
          console.error("Error converting to project:", error);
        }
      );
    };

    $scope.isFormValid = false;

    $scope.checkIsFormValid = function () {
      return (
        !!$scope.formData.id &&
        !!$scope.formData.projectManager &&
        !!$scope.formData.investorDate &&
        !!$scope.formData.feedbackDate
      );
    };

    $scope.onDateChange = function () {
      $scope.isFormValid = $scope.checkIsFormValid();
    };

    $scope.editAppeal = function (appealId) {
      $location.path("/primary-appeals/edit/" + appealId);
    };

    $scope.createAppeal = function () {
      $location.path("/primary-appeals/create");
    };
  },
];
